export const PRODUCT_LIST_REQUEST="PRODUCT_LIST_REQUEST"
export const PRODUCT_LIST_SUCCESS="PRODUCT_LIST_SUCCESS"
export const PRODUCT_LIST_FAIL="PRODUCT_LIST_FAIL"
export const PRODUCT_CLEAR="PRODUCT_CLEAR"

export const PRODUCT_DELETE_REQUEST="PRODUCT_DELETE_REQUEST"
export const PRODUCT_DELETE_SUCCESS="PRODUCT_DELETE_SUCCESS"
export const PRODUCT_DELETE_FAIL="PRODUCT_DELETE_FAIL"

export const PRODUCT_ADD_REQUEST="PRODUCT_ADD_REQUEST"
export const PRODUCT_ADD_SUCCESS="PRODUCT_ADD_SUCCESS"
export const PRODUCT_ADD_FAIL="PRODUCT_ADD_FAIL"

export const PRODUCT_EDIT_REQUEST="PRODUCT_EDIT_REQUEST"
export const PRODUCT_EDIT_SUCCESS="PRODUCT_EDIT_SUCCESS"
export const PRODUCT_EDIT_FAIL="PRODUCT_EDIT_FAIL"

export const PRODUCT_UPDATE_REQUEST="PRODUCT_UPDATE_REQUEST"
export const PRODUCT_UPDATE_SUCCESS="PRODUCT_UPDATE_SUCCESS"
export const PRODUCT_UPDATE_FAIL="PRODUCT_UPDATE_FAIL"
export const PRODUCT_UPDATE_RESET="PRODUCT_UPDATE_RESET"



